module.exports = __webpack_public_path__ + "img/21.c9102223.svg";